export default "__VITE_ASSET__66TlypUB__"